import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { ClientNode } from '~ng-common-lib/nodes/types/node';
import { ImgWithFallbackComponent } from '~ng-common-lib/ui/common/img-with-fallback/img-with-fallback.component';
import { NodeTypeIconDirective } from '~ng-common-lib/ui/icons/node-type-icon.directive';

@Component({
	selector: 'common-node-thumbnail',
	templateUrl: './node-thumbnail.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [ImgWithFallbackComponent, NodeTypeIconDirective],
	host: {
		class: 'br-1 ov-h',
		'[class.bordered]': '$useNodeColor()',
		'[class.border-node-type]': '$useNodeColor()',
		'[class]': '$classes()',
	},
})
export class CommonNodeThumbnailComponent {
	public readonly $useNodeColor = input(true, { alias: 'useNodeColor' });
	public readonly $node = input.required<ClientNode | null>({ alias: 'node' });

	protected readonly $classes = computed(() => {
		const node = this.$node();

		const typeClass = node ? `${node.nodeType}-color`.toLowerCase() : '';

		return typeClass;
	});
}
